/* PW MENU — picks the mascot and one-liner, keeps the cart count fresh and
   hands the cart shortcut to the cart drawer when there is one.
   v92.3: smaller mascot that pops up from below when the drawer opens, bobs gently and types its
   speech bubble; all motion off under prefers-reduced-motion. Adds an Oddly Rewarding row above
   the account and cart shortcuts. */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0888/1628/8064/files/';
  var CAST = [
    { who: 'Rusty', img: 'pwg-rusty-grin-cut.png', line: 'Lost? Same. The blankets are a good place to start.' },
    { who: 'Cash', img: 'pwg-cash-sus-cut.png', line: 'I don\'t trust a menu this short. Click something anyway.' },
    { who: 'Cash', img: 'pwg-cash-palm-cut.png', line: 'Everything in here is weird on purpose. Mostly.' },
    { who: 'Rusty', img: 'pwg-rusty-gasp-cut.png', line: 'You opened the menu. Bold. I respect it.' }
  ];
  var RM = false;
  try { RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var CSS = '' +
    '#menu-drawer .pw-menu__stage{overflow:hidden}' +
    '#menu-drawer .pw-menu__mascot{width:84px!important;height:auto!important;max-width:84px}' +
    '#menu-drawer .pw-or{display:flex;align-items:center;gap:12px;margin:0 0 14px;padding:12px 14px;border:1px solid rgba(242,181,68,.55);color:#FBF8F3;text-decoration:none}' +
    '#menu-drawer .pw-or__n{flex:0 0 auto;display:grid;place-items:center;width:40px;height:40px;background:#F2B544;color:#111B38;font:700 13px/1 Figtree,system-ui,sans-serif}' +
    '#menu-drawer .pw-or b{display:block;font:600 17px/1.2 Fraunces,Georgia,serif;color:#F2B544}' +
    '#menu-drawer .pw-or small{display:block;font-size:13px;line-height:1.3;opacity:.85}' +
    '@media (prefers-reduced-motion:no-preference){' +
      '#menu-drawer .pw-menu__stage .pw-menu__mascot{transform:translateY(110%);opacity:0}' +
      '#menu-drawer .pw-menu__stage.is-in .pw-menu__mascot{animation:pwmUp .55s cubic-bezier(.2,.9,.3,1.25) .1s both,pwmBob 3.2s ease-in-out .8s infinite}' +
      '#menu-drawer .pw-menu__line.is-typing::after{content:"";display:inline-block;width:2px;height:1em;background:currentColor;margin-left:2px;vertical-align:-2px;animation:pwmCaret .7s steps(1) infinite}' +
    '}' +
    '@keyframes pwmUp{from{transform:translateY(110%);opacity:0}to{transform:translateY(0);opacity:1}}' +
    '@keyframes pwmBob{0%,100%{transform:translateY(0)}50%{transform:translateY(-4px)}}' +
    '@keyframes pwmCaret{50%{opacity:0}}';

  function init() {
    var drawer = document.getElementById('menu-drawer');
    if (!drawer) return;
    var details = drawer.closest('details');
    if (!document.getElementById('pw-menu-anim')) {
      var st = document.createElement('style'); st.id = 'pw-menu-anim'; st.textContent = CSS; document.head.appendChild(st);
    }

    // Oddly Rewarding row above the account and cart shortcuts
    var shortcuts = drawer.querySelector('.pw-menu__shortcuts');
    if (shortcuts && !drawer.querySelector('.pw-or')) {
      var a = document.createElement('a');
      a.className = 'pw-or link focus-inset';
      a.href = '/pages/oddly-rewarding';
      a.innerHTML = '<span class="pw-or__n" aria-hidden="true">$5</span><span><b>Oddly Rewarding</b><small>Points on every order and $5 on your birthday. Free to join.</small></span>';
      shortcuts.parentNode.insertBefore(a, shortcuts);
    }

    var stage = drawer.querySelector('.pw-menu__stage');
    var line = stage && stage.querySelector('.pw-menu__line');
    var full = '';
    if (stage) {
      var pick = CAST[Math.floor(Math.random() * CAST.length)];
      var img = stage.querySelector('.pw-menu__mascot');
      var who = stage.querySelector('.pw-menu__bubble b');
      if (img) img.src = CDN + pick.img + '?width=200';
      if (who) who.textContent = pick.who;
      full = pick.line;
      if (line) { line.textContent = full; line.setAttribute('aria-label', full); }
    }

    var typer = 0;
    function type() {
      if (!line || RM) return;
      clearInterval(typer);
      var i = 0;
      line.textContent = '';
      line.classList.add('is-typing');
      typer = setInterval(function () {
        i++;
        line.textContent = full.slice(0, i);
        if (i >= full.length) { clearInterval(typer); setTimeout(function () { line.classList.remove('is-typing'); }, 900); }
      }, 28);
    }
    function show() {
      if (stage.classList.contains('is-in')) return;
      stage.classList.add('is-in');
      setTimeout(type, RM ? 0 : 450);
    }
    function hide() {
      stage.classList.remove('is-in');
      clearInterval(typer);
      if (line) { line.textContent = full; line.classList.remove('is-typing'); }
    }

    // thumbs are lazy so they cost nothing until someone reaches for the menu
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      drawer.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    }
    var summary = details && details.querySelector('summary');
    if (summary) {
      ['pointerenter', 'touchstart', 'focus', 'click'].forEach(function (ev) {
        summary.addEventListener(ev, warm, { passive: true, once: true });
      });
    }

    // Cash or Rusty pops up when the bottom of the drawer is in view
    if (stage && details) {
      if ('IntersectionObserver' in window) {
        var root = drawer.querySelector('.menu-drawer__navigation-container');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting && details.open) show(); });
        }, { root: root, threshold: 0.35 });
        io.observe(stage);
        details.addEventListener('toggle', function () {
          if (!details.open) { hide(); return; }
          io.unobserve(stage);
          io.observe(stage);
        });
      } else {
        stage.classList.add('is-in');
      }
    }

    function syncCount() {
      var out = drawer.querySelector('.pw-menu__count');
      if (!out) return;
      var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
      var n = bubble ? parseInt(bubble.textContent, 10) || 0 : 0;
      out.textContent = n;
      out.setAttribute('data-count', n);
    }
    if (details) details.addEventListener('toggle', function () { if (details.open) syncCount(); });

    var cartLink = drawer.querySelector('.pw-menu__shortcut--cart');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        var cartDrawer = document.querySelector('cart-drawer');
        var icon = document.getElementById('cart-icon-bubble');
        var hd = drawer.closest('header-drawer');
        if (!cartDrawer || !icon || !hd || typeof hd.closeMenuDrawer !== 'function') return;
        e.preventDefault();
        hd.closeMenuDrawer(e);
        setTimeout(function () { icon.click(); }, 60);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();